<ng-container *ngIf="showBlocker">
    <div class="oss-mobile-blocker-modal visible-sm" *ngIf="!asUIView">
        <div class="blocker-message-wrapper">
            <div class="blocker-message">
                {{ 'Message.DesktopResolutionTooSmall' | translate }}
            </div>
        </div>
    </div>
    
    <!--Mobile blocker-->
    <div class="c-mobile-blocker__blocker">
        <div class="c-mobile-blocker__overlay" [class.visible-xs]="!asUIView">
            
            <div class="c-mobile-blocker__body">
                <div class="c-mobile-blocker__image-wrapper">
                    <div
                        class="c-mobile-blocker__image"
                        [ihdAllowedForAppFlavour]="APP_FLAVOUR.DEFAULT"
                    ></div>
                    <div
                        class="c-mobile-blocker__image c-mobile-blocker__image--shift4"
                        [ihdAllowedForAppFlavour]="APP_FLAVOUR.SHIFT4"
                    ></div>
                </div>
                
                <div class="d-flex justify-content-center">
                    <div class="c-mobile-blocker__title">
                        {{ title | translate }}
                    </div>
                    <div class="c-mobile-blocker__sub-title">
                        {{ subtitle | translate }}
                    </div>
                </div>
                <div class="c-mobile-blocker__description">
                    <div class="mb-3">
                        {{ description | translate }}
                    </div>
                    <div>
                        {{ descriptionMore | translate }}
                    </div>
                </div>
            </div>
            
            <div class="c-mobile-blocker__footer">
                <div class="text-uppercase">
                    {{ 'Default.Mobile.Blocker.Apps' | translate }}
                </div>
                <div class="d-flex">
                    <div
                        class="c-mobile-blocker__app"
                        (click)="viewMobileApp('android')"
                    >
                        <div
                            class="c-mobile-blocker__app-icon c-mobile-blocker__app-icon--android"
                        ></div>
                        <div>
                            {{ 'Default.Mobile.Blocker.Android' | translate }}
                        </div>
                    </div>
                    <div
                        class="c-mobile-blocker__app"
                        (click)="viewMobileApp('iphone')"
                    >
                        <div
                            class="c-mobile-blocker__app-icon c-mobile-blocker__app-icon--iphone"
                        ></div>
                        <div>{{ 'Default.Mobile.Blocker.Iphone' | translate }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
